import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';

interface SuccessModalProps {
  isOpen: boolean;
  onClosed: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ isOpen, onClosed }) => {
  return (
    <VbzModal isOpen={isOpen} type="right" desktopSize="small" toggle={onClosed}>
      <ModalBody>
        <div className="modal-title">
          <h3>Recebemos sua solicitação!</h3>
        </div>

        <div className="modal-description">
          <p>
            A equipe do VoeBiz tem até 15 dias úteis para processar as informações. Após o processamento, os pontos do
            seu voo GOL serão disponibilizados em até 24 horas.
          </p>
          <p>Acompanhe o lançamento dos pontos no seu extrato.</p>
        </div>
        <VbzButton
          id="success-modal-btn"
          className="mt-5 smls-register-cpf upgrade-modal-button"
          color="primary"
          text="Entendi"
          onClick={onClosed}
        />
      </ModalBody>
    </VbzModal>
  );
};

export default SuccessModal;
